import { __awaiter } from "tslib";
import log from 'pathfinder/utils/log';
import { callFandomService, callFandomServiceWithBody } from 'pathfinder/utils/api';
const serviceNamePath = 'user-notifications';
export var MarketingNotificationResponseStatus;
(function (MarketingNotificationResponseStatus) {
    MarketingNotificationResponseStatus["SUCCESS"] = "SUCCESS";
    MarketingNotificationResponseStatus["ERROR"] = "ERROR";
})(MarketingNotificationResponseStatus || (MarketingNotificationResponseStatus = {}));
export const getNotifications = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield callFandomService(serviceNamePath);
        if (response.ok) {
            return (yield response.json());
        }
        else {
            log.debug(`Couldn't return notifications data. Response.ok: ${response.ok} | Response.status: ${response.status}`);
            return;
        }
    }
    catch (error) {
        log.error('Error on get notification API', error);
        return;
    }
});
export const fetchActiveNotifications = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield callFandomService('user-notifications/notifications/placement/banner');
        if (response.ok) {
            return (yield response.json());
        }
        else {
            log.debug(`Couldn't return active notifications data. Response.ok: ${response.ok} | Response.status: ${response.status}`);
            return;
        }
    }
    catch (error) {
        log.error('Error on get active notification API', error);
        return;
    }
});
export const addNotification = (body) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield callFandomServiceWithBody(serviceNamePath, Object.assign({}, body));
        if (response.ok) {
            return { status: MarketingNotificationResponseStatus.SUCCESS };
        }
        else {
            log.error(`The notification wasn't added. Response: ${response}`);
            return { status: MarketingNotificationResponseStatus.ERROR };
        }
    }
    catch (error) {
        log.error('Error on post notification API', error);
        return { status: MarketingNotificationResponseStatus.ERROR };
    }
});
export const editNotification = (body, id) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield callFandomServiceWithBody(`${serviceNamePath}/${id}`, Object.assign({}, body), { method: 'PUT' });
        if (response.ok) {
            return { status: MarketingNotificationResponseStatus.SUCCESS };
        }
        else {
            log.debug(`The notification wasn't edited. Response: ${response}`);
            return { status: MarketingNotificationResponseStatus.ERROR };
        }
    }
    catch (error) {
        log.error('Error on PUT notification API', error);
        return { status: MarketingNotificationResponseStatus.ERROR };
    }
});
export const deactivateNotification = (id) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield callFandomServiceWithBody(`${serviceNamePath}/deactivate/${id}`, {}, { method: 'PUT' });
        if (response.ok) {
            return { status: MarketingNotificationResponseStatus.SUCCESS };
        }
        else {
            log.error(`The notification couldn't be deactivated. Response: ${response}`);
            return { status: MarketingNotificationResponseStatus.ERROR };
        }
    }
    catch (error) {
        log.error('Error on deactivate notification API', error);
        return { status: MarketingNotificationResponseStatus.ERROR };
    }
});
const limitResults = 20;
export const getWikiCommunities = (query) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = `unified-search/community-search?query=${query}&limit=${limitResults}`;
        const response = yield callFandomService(url);
        if (response.ok) {
            const { results } = (yield response.json());
            return results.map(({ name, url, language, id }) => ({
                id,
                label: `${name} (${language}) - ${url}`,
                value: `${name} (${language})`,
            }));
        }
        else {
            log.debug(`Couldn't return communities. Response.status: ${response.status}`);
            return;
        }
    }
    catch (error) {
        log.error('Error on community-search API', error);
        return;
    }
});
